"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Detail = _interopRequireDefault(require("@rsuite/icon-font/lib/file/Detail"));

// Generated by script, don't edit it please.
var Detail = (0, _createSvgIcon["default"])({
  as: _Detail["default"],
  ariaLabel: 'detail',
  category: 'file',
  displayName: 'Detail'
});
var _default = Detail;
exports["default"] = _default;
module.exports = exports.default;